/**
 * AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
 *
 * This file is generated by packages/server/scripts/generate-permissions.ts
 * Run `pnpm generate:permissions` from packages/server to regenerate.
 *
 * Source of truth: SERVER_ROUTES in @mastra/server
 */

/**
 * All known API resources.
 * Derived from SERVER_ROUTES paths in @mastra/server.
 */
export const RESOURCES = [
  'a2a',
  'agent-builder',
  'agents',
  'datasets',
  'embedders',
  'experiments',
  'logs',
  'mcp',
  'memory',
  'observability',
  'processor-providers',
  'processors',
  'scores',
  'stored',
  'stored-agents',
  'system',
  'tool-providers',
  'tools',
  'vector',
  'vectors',
  'workflows',
  'workspaces',
] as const;

/**
 * Resource type union.
 */
export type Resource = (typeof RESOURCES)[number];

/**
 * All permission actions.
 * Derived from HTTP methods and route overrides:
 * - GET → read
 * - POST → write or execute (context-dependent)
 * - PUT/PATCH → write
 * - DELETE → delete
 * - Additional actions from explicit requiresPermission overrides
 */
export const ACTIONS = ['delete', 'execute', 'read', 'write'] as const;

/**
 * Action type union.
 */
export type Action = (typeof ACTIONS)[number];

/**
 * All valid permission patterns.
 * Use `keyof typeof PERMISSION_PATTERNS` or the `PermissionPattern` type.
 */
export const PERMISSION_PATTERNS = {
  /** Full access to all resources and actions */
  '*': '*',
  /** Delete all resources */
  '*:delete': '*:delete',
  /** Execute all resources */
  '*:execute': '*:execute',
  /** View all resources */
  '*:read': '*:read',
  /** Create and modify all resources */
  '*:write': '*:write',
  /** Full access to agent-to-agent communication */
  'a2a:*': 'a2a:*',
  /** Full access to agent builder */
  'agent-builder:*': 'agent-builder:*',
  /** Full access to agents */
  'agents:*': 'agents:*',
  /** Full access to datasets */
  'datasets:*': 'datasets:*',
  /** Full access to embedders */
  'embedders:*': 'embedders:*',
  /** Full access to experiments */
  'experiments:*': 'experiments:*',
  /** Full access to logs */
  'logs:*': 'logs:*',
  /** Full access to MCP servers */
  'mcp:*': 'mcp:*',
  /** Full access to memory and threads */
  'memory:*': 'memory:*',
  /** Full access to traces and spans */
  'observability:*': 'observability:*',
  /** Full access to processor-providers */
  'processor-providers:*': 'processor-providers:*',
  /** Full access to processors */
  'processors:*': 'processors:*',
  /** Full access to evaluation scores */
  'scores:*': 'scores:*',
  /** Full access to stored */
  'stored:*': 'stored:*',
  /** Full access to stored agents */
  'stored-agents:*': 'stored-agents:*',
  /** Full access to system info */
  'system:*': 'system:*',
  /** Full access to tool-providers */
  'tool-providers:*': 'tool-providers:*',
  /** Full access to tools */
  'tools:*': 'tools:*',
  /** Full access to vector stores */
  'vector:*': 'vector:*',
  /** Full access to vectors */
  'vectors:*': 'vectors:*',
  /** Full access to workflows */
  'workflows:*': 'workflows:*',
  /** Full access to workspaces */
  'workspaces:*': 'workspaces:*',
  /** View agent-to-agent communication */
  'a2a:read': 'a2a:read',
  /** Create and modify agent-to-agent communication */
  'a2a:write': 'a2a:write',
  /** Execute agent builder */
  'agent-builder:execute': 'agent-builder:execute',
  /** View agent builder */
  'agent-builder:read': 'agent-builder:read',
  /** Create and modify agent builder */
  'agent-builder:write': 'agent-builder:write',
  /** Execute agents */
  'agents:execute': 'agents:execute',
  /** View agents */
  'agents:read': 'agents:read',
  /** Create and modify agents */
  'agents:write': 'agents:write',
  /** Delete datasets */
  'datasets:delete': 'datasets:delete',
  /** Execute datasets */
  'datasets:execute': 'datasets:execute',
  /** View datasets */
  'datasets:read': 'datasets:read',
  /** Create and modify datasets */
  'datasets:write': 'datasets:write',
  /** View embedders */
  'embedders:read': 'embedders:read',
  /** View experiments */
  'experiments:read': 'experiments:read',
  /** View logs */
  'logs:read': 'logs:read',
  /** Execute MCP servers */
  'mcp:execute': 'mcp:execute',
  /** View MCP servers */
  'mcp:read': 'mcp:read',
  /** Create and modify MCP servers */
  'mcp:write': 'mcp:write',
  /** Delete memory and threads */
  'memory:delete': 'memory:delete',
  /** Execute memory and threads */
  'memory:execute': 'memory:execute',
  /** View memory and threads */
  'memory:read': 'memory:read',
  /** Create and modify memory and threads */
  'memory:write': 'memory:write',
  /** View traces and spans */
  'observability:read': 'observability:read',
  /** Create and modify traces and spans */
  'observability:write': 'observability:write',
  /** View processor-providers */
  'processor-providers:read': 'processor-providers:read',
  /** Execute processors */
  'processors:execute': 'processors:execute',
  /** View processors */
  'processors:read': 'processors:read',
  /** View evaluation scores */
  'scores:read': 'scores:read',
  /** Create and modify evaluation scores */
  'scores:write': 'scores:write',
  /** Delete stored agents */
  'stored-agents:delete': 'stored-agents:delete',
  /** View stored agents */
  'stored-agents:read': 'stored-agents:read',
  /** Create and modify stored agents */
  'stored-agents:write': 'stored-agents:write',
  /** Delete stored */
  'stored:delete': 'stored:delete',
  /** View stored */
  'stored:read': 'stored:read',
  /** Create and modify stored */
  'stored:write': 'stored:write',
  /** View system info */
  'system:read': 'system:read',
  /** View tool-providers */
  'tool-providers:read': 'tool-providers:read',
  /** Execute tools */
  'tools:execute': 'tools:execute',
  /** View tools */
  'tools:read': 'tools:read',
  /** Delete vector stores */
  'vector:delete': 'vector:delete',
  /** Execute vector stores */
  'vector:execute': 'vector:execute',
  /** View vector stores */
  'vector:read': 'vector:read',
  /** Create and modify vector stores */
  'vector:write': 'vector:write',
  /** View vectors */
  'vectors:read': 'vectors:read',
  /** Delete workflows */
  'workflows:delete': 'workflows:delete',
  /** Execute workflows */
  'workflows:execute': 'workflows:execute',
  /** View workflows */
  'workflows:read': 'workflows:read',
  /** Create and modify workflows */
  'workflows:write': 'workflows:write',
  /** Delete workspaces */
  'workspaces:delete': 'workspaces:delete',
  /** View workspaces */
  'workspaces:read': 'workspaces:read',
  /** Create and modify workspaces */
  'workspaces:write': 'workspaces:write',
} as const;

/**
 * Permission pattern that can be used in role definitions.
 * Supports:
 * - Specific permissions: 'agents:read', 'workflows:execute'
 * - Resource wildcards: 'agents:*', 'workflows:*' (all actions on a resource)
 * - Action wildcards: '*:read', '*:write' (an action across all resources)
 * - Global wildcard: '*' (full access)
 */
export type PermissionPattern = keyof typeof PERMISSION_PATTERNS;

/**
 * All valid resource:action permission combinations (excludes wildcards).
 */
export const PERMISSIONS = [
  'a2a:read',
  'a2a:write',
  'agent-builder:execute',
  'agent-builder:read',
  'agent-builder:write',
  'agents:execute',
  'agents:read',
  'agents:write',
  'datasets:delete',
  'datasets:execute',
  'datasets:read',
  'datasets:write',
  'embedders:read',
  'experiments:read',
  'logs:read',
  'mcp:execute',
  'mcp:read',
  'mcp:write',
  'memory:delete',
  'memory:execute',
  'memory:read',
  'memory:write',
  'observability:read',
  'observability:write',
  'processor-providers:read',
  'processors:execute',
  'processors:read',
  'scores:read',
  'scores:write',
  'stored-agents:delete',
  'stored-agents:read',
  'stored-agents:write',
  'stored:delete',
  'stored:read',
  'stored:write',
  'system:read',
  'tool-providers:read',
  'tools:execute',
  'tools:read',
  'vector:delete',
  'vector:execute',
  'vector:read',
  'vector:write',
  'vectors:read',
  'workflows:delete',
  'workflows:execute',
  'workflows:read',
  'workflows:write',
  'workspaces:delete',
  'workspaces:read',
  'workspaces:write',
] as const;

/**
 * Specific permission type (e.g., 'agents:read', 'workflows:execute').
 */
export type Permission = (typeof PERMISSIONS)[number];

/**
 * Type-safe role mapping configuration.
 *
 * Maps role names (from your identity provider) to Mastra permission patterns.
 *
 * @example
 * ```typescript
 * const roleMapping: TypedRoleMapping = {
 *   "Engineering": ["agents:*", "workflows:*"],
 *   "Product": ["agents:read", "workflows:read"],
 *   "Admin": ["*"],
 *   "_default": [],
 * };
 * ```
 */
export type TypedRoleMapping = {
  [role: string]: PermissionPattern[];
};

/**
 * Validates that a string is a valid permission pattern.
 * Useful for runtime validation of permission strings.
 */
export function isValidPermissionPattern(pattern: string): pattern is PermissionPattern {
  return pattern in PERMISSION_PATTERNS;
}

/**
 * Validates that all permissions in an array are valid patterns.
 */
export function validatePermissions(permissions: string[]): permissions is PermissionPattern[] {
  return permissions.every(isValidPermissionPattern);
}
